const appBase = {
    palette: {
        primary: {
            main: '#E86C2D',
            dark: '#AF3D00',
            light: '#FF9C58'
        },
        secondary: {
            main: '#3A8445',
            light: '#A2E8F3'
        },
        error: {
            main: '#D93731',
            light: '#E57373'
        },
        info: {
            main: '#4B7594',
            light: '#ffe066'
        },
        success: {
            main: '#3A8445',
            light: '#00C61A'
        },
        warning: {
            main: '#F6C245',
            light: '#FFF477'
        },
        /*begin FS custom*/
        /*end FS custom*/
        tonalOffset: 0.2
    }
};

export default appBase;